var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "financeApplication__form" }, [
    !_vm.isManualAddressFormVisible
      ? _c(
          "div",
          { staticClass: "financeApplication__form__fields" },
          [
            _c("FinanceApplicationAddressLookup", {
              attrs: { "initial-postcode": _vm.employment.postcode },
              on: {
                "address-suggestion": _vm.onAddressSuggestion,
                "show-manual-address-form": _vm.onManualAddressForm,
              },
            }),
          ],
          1
        )
      : _c(
          "form",
          { staticClass: "financeApplication__manualAddressForm" },
          [
            _c("ValidationObserver", { ref: "observer" }, [
              _c(
                "div",
                { class: _vm.manualFormClassNames },
                [
                  _c("ValidationProvider", {
                    attrs: {
                      name: "address line 1",
                      rules: _vm.validationRules,
                      slim: "",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (ref) {
                          var errors = ref.errors
                          return [
                            _c(
                              "FinanceApplicationRow",
                              {
                                attrs: {
                                  "error-message": errors[0],
                                  id: "addressLine1",
                                  label: "Address Line 1",
                                },
                              },
                              [
                                _c("FinanceApplicationText", {
                                  attrs: {
                                    id: "addressLine1",
                                    placeholder: "Address line 1",
                                  },
                                  model: {
                                    value: _vm.employment.addressLine1,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.employment,
                                        "addressLine1",
                                        $$v
                                      )
                                    },
                                    expression: "employment.addressLine1",
                                  },
                                }),
                              ],
                              1
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c(
                    "FinanceApplicationRow",
                    { attrs: { id: "addressLine2", label: "Address Line 2" } },
                    [
                      _c("FinanceApplicationText", {
                        attrs: {
                          id: "addressLine2",
                          placeholder: "Address line 2",
                        },
                        model: {
                          value: _vm.employment.addressLine2,
                          callback: function ($$v) {
                            _vm.$set(_vm.employment, "addressLine2", $$v)
                          },
                          expression: "employment.addressLine2",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("ValidationProvider", {
                    attrs: {
                      name: "town/city",
                      rules: _vm.validationRules,
                      slim: "",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (ref) {
                          var errors = ref.errors
                          return [
                            _c(
                              "FinanceApplicationRow",
                              {
                                attrs: {
                                  "error-message": errors[0],
                                  id: "townCity",
                                  label: "Town/city",
                                },
                              },
                              [
                                _c("FinanceApplicationText", {
                                  attrs: {
                                    id: "townCity",
                                    placeholder: "Town/city",
                                  },
                                  model: {
                                    value: _vm.employment.city,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.employment, "city", $$v)
                                    },
                                    expression: "employment.city",
                                  },
                                }),
                              ],
                              1
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("ValidationProvider", {
                    attrs: {
                      name: "postcode",
                      rules: _vm.validationRules,
                      slim: "",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (ref) {
                          var errors = ref.errors
                          return [
                            _c(
                              "FinanceApplicationRow",
                              {
                                attrs: {
                                  "error-message": errors[0],
                                  id: "postcode",
                                  label: "Postcode",
                                },
                              },
                              [
                                _c("FinanceApplicationText", {
                                  attrs: {
                                    id: "postcode",
                                    placeholder: "Postcode",
                                  },
                                  model: {
                                    value: _vm.employment.postcode,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.employment, "postcode", $$v)
                                    },
                                    expression: "employment.postcode",
                                  },
                                }),
                              ],
                              1
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
            ]),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass:
                  "financeApplication__addressSelector__manualAddress",
                attrs: { type: "button" },
                on: { click: _vm.onManualAddressForm },
              },
              [_vm._v("Go back to search by postcode")]
            ),
          ],
          1
        ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }